<div class="security flex flex-col justify-between h-full">
	<app-loading-spinner *ngIf="loading"></app-loading-spinner>

	<div class="content-security flex justify-center items-center pt-5 px-5" *ngIf="!loading">
		<div class="flex flex-col md:flex-row justify-start w-full">
			<!-- 1 -->
			<div class="policies w-[45%] pr-14">
				<span class="font-lato text-complementary-color-b font-bold text-2xl">{{
					dataTranslateSecurity.title2
				}}</span>
				<div class="minimum ml-4 pt-5 pb-8 border-b border-neutral-color-c">
					<div class="text">
						<div class="title flex flex-col w-full">
							<span class="font-lato text-xl text-primary-color font-bold">{{
								dataTranslateSecurity.titleMinimun
							}}</span>
							<span class="font-lato text-base font-normal">{{
								dataTranslateSecurity.descriptionMinimun
							}}</span>
						</div>
					</div>
					<div class="range pt-4">
						{{ rangeValues }}
						<p-slider
							[(ngModel)]="rangeValues"
							[ariaLabelledBy]="'label'"
							[min]="4"
							[disabled]="isEdit"
							[max]="30"
						></p-slider>
					</div>
				</div>
				<div class="character ml-4 pt-5 pb-8 border-b border-neutral-color-c">
					<div class="title flex flex-col w-full">
						<div class="tite-text flex justify-between items-center">
							<span class="font-lato text-xl text-primary-color font-bold"
								>{{ dataTranslateSecurity.titleCharacter }}
							</span>
							<div class="check">
								<p-inputSwitch [(ngModel)]="checked" [disabled]="isEdit"></p-inputSwitch>
							</div>
						</div>
						<span class="font-lato text-base font-normal">{{
							dataTranslateSecurity.descriptionCharacter
						}}</span>
					</div>
				</div>
				<div class="validity ml-4 pt-5 pb-8 border-b border-neutral-color-c">
					<div class="text">
						<div class="title flex flex-col w-full">
							<span class="font-lato text-xl text-primary-color font-bold">{{
								dataTranslateSecurity.titleValidity
							}}</span>
							<span class="font-lato text-base font-normal">{{
								dataTranslateSecurity.descriptionValidity
							}}</span>
						</div>
					</div>
					<div class="range pt-4">
						{{ password }}
						<p-slider
							[(ngModel)]="password"
							[ariaLabelledBy]="'label'"
							[min]="0"
							[disabled]="isEdit"
							[max]="12"
						></p-slider>
					</div>
				</div>
				<div class="refresh ml-4 pt-4">
					<div class="title flex flex-col w-full">
						<span class="font-lato text-xl text-primary-color font-bold">{{
							dataTranslateSecurity.titleRefresh
						}}</span>
						<span class="font-lato text-base font-normal">
							{{ dataTranslateSecurity.textRefresh }}
						</span>
					</div>
					<div class="flex gap-4 items-center pt-1">
						<input
							class="input-app !w-[70px] text-center"
							[(ngModel)]="minutes"
							[disabled]="isEdit"
							placeholder="01"
							type="text"
						/>
						<span>{{ dataTranslateSecurity.minutes }} </span>
					</div>
				</div>
			</div>
			<hr
				class="border border-neutral-color-c mt-10 w-full h-1 md:!w-[calc(1px)] md:h-[calc(100vh-500px)]"
			/>
			<!-- 2 -->
			<div class="security w-[45%] pl-12 cursor-default">
				<span class="font-lato text-complementary-color-b font-bold text-2xl">
					{{ dataTranslateSecurity.title }}
				</span>
				<div class="title pl-4 flex flex-col">
					<span class="font-lato text-base font-normal pt-0.5 pb-7 border-b border-neutral-color-c">
						{{ dataTranslateSecurity.description }}
					</span>
				</div>

				<div
					class="password ml-4 py-5 flex flex-row justify-between w-full items-center border-b border-neutral-color-c"
				>
					<div class="icon w-2/12">
						<img src="../../../../../../assets/icon/lock.svg" alt="" />
					</div>
					<div class="description flex flex-col w-5/6">
						<span class="font-lato text-xl text-primary-color font-bold"
							>1. {{ dataTranslateSecurity.titlePassword }}</span
						>
						<span class="font-lato text-base font-normal">{{
							dataTranslateSecurity.descriptionPassword
						}}</span>
					</div>
					<div class="check w-2/12 flex justify-end items-center">
						<input
							type="radio"
							id="password"
							name="auth"
							value="password"
							checked
							[ngModel]="methodPassword"
							[disabled]="isEdit"
							(click)="onChangeSecurity('password')"
						/>
					</div>
				</div>
				<div
					class="sms ml-4 py-5 flex flex-row justify-between w-full items-center border-b border-neutral-color-c"
				>
					<div class="icon w-2/12">
						<img src="../../../../../../assets/icon/lock-1.svg" alt="" />
					</div>
					<div class="description flex flex-col w-5/6">
						<span class="font-lato text-xl text-primary-color font-bold"
							>2.{{ dataTranslateSecurity.titleSms }}</span
						>
						<span class="font-lato text-base font-normal">{{
							dataTranslateSecurity.descriptionSms
						}}</span>
					</div>
					<div class="check w-2/12 flex justify-end items-center">
						<input
							type="radio"
							id="sms"
							name="auth"
							value="sms"
							[ngModel]="methodPassword"
							[disabled]="isEdit"
							(click)="onChangeSecurity('sms')"
						/>
					</div>
				</div>
				<div
					class="totop ml-4 py-5 flex flex-row justify-between w-full items-center border-b border-neutral-color-c"
				>
					<div class="icon w-2/12">
						<img src="../../../../../../assets/icon/lock-2.svg" alt="" />
					</div>
					<div class="description flex flex-col w-5/6">
						<span class="font-lato text-xl text-primary-color font-bold"
							>3. {{ dataTranslateSecurity.titleTotp }}</span
						>
						<span class="font-lato text-base font-normal">{{
							dataTranslateSecurity.descriptionTotp
						}}</span>
					</div>
					<div class="check w-2/12 flex justify-end items-center">
						<input
							type="radio"
							id="totp"
							name="auth"
							value="totp"
							[ngModel]="methodPassword"
							[disabled]="isEdit"
							(click)="onChangeSecurity('totp')"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="buttons flex items-center justify-end h-16 pr-4">
		<button class="px-3" (click)="updateGroup()">
			<mat-icon class="text-primary-color mr-2"> {{ isEdit ? 'edit' : 'save' }} </mat-icon>
			<span class="font-lato">{{
				isEdit ? dataTranslateSecurity.buttonEdit : dataTranslateSecurity.buttonSave
			}}</span>
		</button>
	</div>
</div>
